<template>
    <div
        class="kgr-inputGroup"
        :class="{ 'with-errors': error.forField('file') }"
    >
        <div class="kgr-inputGroup__label ui-droppable">
            {{ $t('Team-Bild') }}
        </div>

        <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--center kgr-row kgr-row--smallMargin">
            <div class="kgr-postfix__fixed">
                <img
                    :src="imageUrl"
                    :alt="team.name"
                    :style="addStyle"
                />
            </div>
            <div class="kgr-postfix__fluid">
                <template v-if="imageFile">
                    <kgr-button
                        :value="$t('Bild hochladen')"
                        :pending="pendingUpload"
                        type="blue"
                        @click="uploadImage"
                    />
                </template>
                <template v-if="team.hasImage && !imageFile">
                    <a
                        class="kgr-button kgr-button--small kgr-button--danger"
                        href="javascript:void(0);"
                        @click="deleteImage()"
                    >{{ $t('Bild löschen?') }}</a>
                    <input
                        id="check_remove_image"
                        type="hidden"
                        value="0"
                        name="check_remove_image"
                    />
                </template>
            </div>
        </div>
        <kgr-drop-file
            ref="dropFile"
            jpg-png-gif-only
            show-size
            @change="onImageChange"
        />

        <div
            v-if="error.forField('file')"
            class="kgr-inputGroup__text kgr-inputGroup__text--error"
        >
            {{ error.messageForField('file') }}
        </div>
        <div class="kgr-inputGroup__text">
            {{ $t('Hier kannst du ein Bild einfügen. Die Datei (z.B. JPG, PNG oder GIF) sollte eine Mindestbreite von 300 Pixel haben und darf eine Dateigröße von 2 MB nicht überschreiten.') }}
        </div>
    </div>
</template>

<script>
import DropFile from '../common/form/input/DropFile.vue';
import Error from '../../js/model/Error';
import KgrButton from '../common/form/button/KgrButton';
import Team from '../../js/dto/Team';
import TeamRepository from '../../js/repository/TeamRepository';

export default {
    name: 'KgrTeamImageFormRow',
    components: {
        'kgr-button': KgrButton,
        'kgr-drop-file': DropFile,
    },
    props: {
        team: {
            type: Team,
            required: true,
        },
        addStyle: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            imageFile: null,
            error: new Error(),
            pendingUpload: false,
            cacheBreaker: Date.now(),
        };
    },
    computed: {
        imageUrl() {
            return `${this.team.imageUrl}?v=${this.cacheBreaker}`;
        },
    },
    methods: {
        deleteImage() {
            showConfirm(this.$t('confirm'), this.$t('Soll das Bild wirklich gelöscht werden?'), () => {
                TeamRepository.removeImage(this.team)
                    .then(() => {
                        this.error = new Error();
                        this.cacheBreaker = Date.now();
                        this.team.hasImage = false;
                        this.$forceUpdate();
                        this.$notify.success('team.image.delete.success');
                    })
                    .catch((error) => this.handleError(error));
                this.imageFile = null;
            }, 'Ok');
        },
        onImageChange(imageFile) {
            this.imageFile = imageFile;
        },
        uploadImage() {
            if (this.imageFile) {
                this.pendingUpload = true;
                TeamRepository.uploadImage(this.team, this.imageFile)
                    .then(() => {
                        this.error = new Error();
                        this.cacheBreaker = Date.now();
                        this.team.hasImage = true;
                        this.imageFile = null;
                        this.$refs.dropFile.resetFiles();
                        this.$forceUpdate();
                        this.$notify.success('Bild erfolgreich hochgeladen');
                    })
                    .catch((error) => this.handleError(error))
                    .finally(() => this.pendingUpload = false);
            }
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
